import type { Thunk } from 'state';

export function streamingReconnectedThunk(connectionId: string, driver: string): Thunk<void> {
  return (dispatch, getState, { actionCreators: ac, selectors: sl }) => {
    dispatch(ac.streamingReconnected(connectionId, driver));
    dispatch(ac.espStreamsRefreshEpic(connectionId, sl.getEspStreamKeys(getState())));
  };
}
